function createCookie(cookieName,cookieValue,daysToExpire){
  var date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString()+ "; path=/";
}

function accessCookie(cookieName){
  var name = cookieName + "=";
  var allCookieArray = document.cookie.split(';');
  for(var i=0; i<allCookieArray.length; i++){
    var temp = allCookieArray[i].trim();
    if (temp.indexOf(name)==0){
      return temp.substring(name.length,temp.length);
    }
  }
  return "";
}

function checkCookie(){
  var user = accessCookie("over_age");
  if (user!=""){
    // console.log("You're over 18: " + user + "!!!");
    $(".modaldisclaimer").remove();
  }
  else{
    $(".modaldisclaimer").show();
  }
}

$(document).ready(function () {
  if (Shopify.designMode) {
    // console.log("modo diseñador")
  }
  else{
    checkCookie();
    $('#popaviso-btn').click(function(){
     var user = accessCookie("over_age");
     if (user!=""){
    }
    else{
     createCookie("over_age", "yes ", 1);
    }
    $(".modaldisclaimer").hide();
    }); 
  }
});
